export const FINE_FIELDS = [  
  { key: "administration_cost", label: "administration_cost" },
  { key: "picture", label: "picture", type: 'file' },
]

export const FINE_REQUIRED_FIELDS = [
  { key: "date", label: "date", type: 'date' },
  { key: "cost", label: "cost" },
];

export const FIELDS = [...FINE_REQUIRED_FIELDS, ...FINE_FIELDS]

